import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
const TableCaptionBox = ({ caption, captionAction, captionSx, minHeight = "2.5rem" }) => {
    if (!caption && !captionAction) {
        return null;
    }
    return (_jsxs(Box, Object.assign({ sx: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            minHeight: minHeight,
        } }, { children: [caption && (_jsx(Typography, Object.assign({ variant: "h3", sx: captionSx }, { children: caption }))), captionAction && captionAction] })));
};
export default TableCaptionBox;
